import { RedeemService } from "@/services";
import $thousandMask from "@/mixins/thousandMask";

export default {
  name: "dashboard-discount-code",
  mixins: [$thousandMask],
  data() {
    return {
      discountCode: "",
      showDialog: false,
      loadingBtn: false,
      currencyData: {},
      imageBaseUrl: process.env.VUE_APP_IMAGE_BASE_URL
    };
  },

  computed: {
    showDialogMessage() {
      if (this.currencyData.actionType == "STAKE") {
        return this.$t("dashboardPage.discountCard.yourCodeConfirmed");
      }
      return this.$t("dashboardPage.discountCard.priceAdded");
    },

    marketStakingUrl() {
      return `${process.env.VUE_APP_MARKET_BASE_URL}/staking`;
    }
  },

  watch: {
    showDialog(newValue) {
      if (!newValue) {
        this.currencyData = {};
      }
    }
  },

  methods: {
    submitClick() {
      this.loadingBtn = true;
      RedeemService.use(this.discountCode)
        .then(response => {
          if (response.data.code === 0) {
            this.currencyData = response.data.data;
            this.showDialog = true;
          } else {
            this.$toast.error(response.data.message);
          }
        })
        .finally(() => {
          this.loadingBtn = false;
        });
    },
    closeDialog() {
      this.showDialog = false;
      this.currencyData = {};
    }
  }
};
